// removed by extract-text-webpack-plugin
module.exports = {"nav_list_items":"Navigation__nav_list_items__1n3pJ"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/Navigation.css
// module id = 30
// module chunks = 0